export default __webpack_public_path__ + "static/media/copy.9db3c07f.png";